var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoShape(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "144px",
    height: "114px",
    viewBox: "0 0 144 114",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#006A35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.46834286,91.9378286 C21.3613714,92.3904 65.8368,95.2827429 117.841371,111.752229 L117.545143,113.089371 L106.831543,113.089371 C84.2893714,106.202057 49.1616,99.8989714 0.826971429,103.634743 L3.46834286,91.9419429 L3.46834286,91.9378286 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.43405714,65.4747429 C23.2169143,67.9021714 48.1824,74.9499429 89.1771429,94.6697143 C69.5931429,87.4409143 42.1467429,80.8374857 6.17142857,79.9405714 L9.43405714,65.4747429 L9.43405714,65.4747429 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.9835429,65.4130286 C68.9677714,64.5737143 114.327771,77.2498286 124.926171,80.3602286 L118.968686,106.769829 C106.720457,98.1627429 82.1746286,83.7421714 35.9835429,65.4130286 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.432,61.2864 C96.4347429,56.4891429 118.594286,57.6987429 129.637029,59.4596571 L127.032686,71.0331429 C92.5138286,63.2736 69.4656,61.1424 54.432,61.2864 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9963429,58.2294857 C109.723886,40.9371429 128.357486,45.3846857 132.48,45.5657143 L131.221029,52.4653714 C103.215086,49.0422857 74.8388571,52.8768 51.9963429,58.2294857 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.2125714,0 L143.061943,0 L134.203886,39.2256 C95.8752,37.5387429 61.4921143,51.6219429 37.1478857,62.1092571 C35.2676571,62.6441143 33.4532571,63.1913143 31.7088,63.7302857 C25.0181687,61.1160264 18.2977253,58.5787161 11.5488,56.1188571 L24.2166857,0 L24.2125714,0 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoShape);
export default __webpack_public_path__ + "static/media/logo-shape.4de171dbf9814082c6c3c9fe400c6c94.svg";
export { ForwardRef as ReactComponent };